import React, { useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../common/Loader';
import { Container } from 'react-bootstrap';
import MetaData from '../MetaData';
import SectionHeading from '../common/SectionHeading';
import { clearErrors } from '../../redux/actions/userAction';
import { BsFillTrashFill, BsFillPencilFill } from 'react-icons/bs';
import Table from 'react-bootstrap/Table';
import { useNavigate, Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Row, Col } from 'react-bootstrap';
import { DELETE_USER_RESET } from '../../redux/constants/userConstants';
import { deleteUser, getAllUsers } from '../../redux/actions/userAction';

const UserList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, users, error } = useSelector((state) => state.allUsers);
    const { isDeleted, error: deleteError, message } = useSelector((state) => state.profile);

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
        if (deleteError) {
            toast.error(deleteError);
            dispatch(clearErrors());
        }

        if (isDeleted) {
            toast.success(message);
            dispatch({ type: DELETE_USER_RESET });
            navigate('/admin/users');
        }

        dispatch(getAllUsers());
    }, [error, deleteError, isDeleted, message]);

    const handleDeleteUser = (id) => {
        dispatch(deleteUser(id));
    };

    return loading ? (
        <Loader />
    ) : (
        <>
            <MetaData title={`All Users - Admin`} />
            <Container>
                <div className='myOrdersPage section-padding-top section-padding-bottom'>
                    <SectionHeading heading={'All Users'} />
                    <Row>
                        <Col md={3}>
                            <Sidebar />
                        </Col>
                        <Col md={9}>
                            <div className='scrollableTable'>
                                <Table striped bordered hover className='commonTable'>
                                    <thead>
                                        <tr>
                                            <th>User ID</th>
                                            <th>Email</th>
                                            <th>Name</th>
                                            <th>Role</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users &&
                                            users.length > 0 &&
                                            users.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{item._id}</td>
                                                    <td>{item.email}</td>
                                                    <td>{item.name}</td>
                                                    <td
                                                        className={
                                                            item.role.toLowerCase() === 'admin'
                                                                ? 'text-success'
                                                                : 'text-danger'
                                                        }
                                                    >
                                                        {item.role}
                                                    </td>
                                                    <td>
                                                        <Link to={`/admin/user/${item._id}`}>
                                                            <BsFillPencilFill />
                                                        </Link>
                                                        <button
                                                            className='common-btn'
                                                            onClick={() =>
                                                                handleDeleteUser(item._id)
                                                            }
                                                        >
                                                            <BsFillTrashFill />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </>
    );
};

export default UserList;
